import { ElectionType, electionTypeMap } from '../api/api-types';
import { createSearchParams } from './search-params';

const buildUrl = (
  baseUrl: string | undefined,
  params: Record<string, string | number | undefined>,
) => {
  if (!baseUrl) return undefined;

  const [pathname, queryString] = baseUrl.split('?');
  const searchParams = createSearchParams(queryString ?? '');

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      searchParams.delete(key);
      return;
    }
    searchParams.set(key, String(value));
  });

  const query = searchParams.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export const buildPartyDetailsUrl = (
  partyDetailsUrl: string | undefined,
  partyId: string | null | undefined,
  electionType?: ElectionType,
) =>
  buildUrl(partyDetailsUrl, {
    election:
      electionType !== undefined ? electionTypeMap[electionType] : undefined,
    party: partyId ?? undefined,
  });

export const buildDialogUrl = (
  dialogPageUrl: string | undefined,
  {
    type,
    electionType,
    party,
    choice,
    extraParams,
  }: {
    type?: string;
    electionType?: ElectionType;
    party?: string;
    choice?: 'dk' | 'eu';
    extraParams?: Record<string, string | number | undefined>;
  },
) =>
  buildUrl(dialogPageUrl, {
    type,
    electionType,
    party,
    choice,
    ...(extraParams || {}),
  });
